import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  ACQUISITION_FEATURE_KEY,
  AcquisitionState,
  AcquisitionPartialState,
  acquisitionAdapter,
} from "./acquisition.reducer";
import { LandTitleDto } from "@cradua/data";

// Lookup the 'Acquisition' feature state managed by NgRx
export const getAcquisitionState = createFeatureSelector<
  AcquisitionPartialState,
  AcquisitionState
>(ACQUISITION_FEATURE_KEY);

const { selectAll, selectEntities } = acquisitionAdapter.getSelectors();

// export const getAcquisitionLoaded = createSelector(
//   getAcquisitionState,
//   (state: AcquisitionState) => state.loaded,
// );

export const getAcquisitionError = createSelector(
  getAcquisitionState,
  (state: AcquisitionState) => state.error,
);

export const loadingAcquisition = createSelector(
  getAcquisitionState,
  (state: AcquisitionState) => state.loaded,
);

export const getAllAcquisition = createSelector(
  getAcquisitionState,
  (state: AcquisitionState) => selectAll(state),
);

export const getAcquisitionEntities = createSelector(
  getAcquisitionState,
  (state: AcquisitionState) => selectEntities(state),
);

export const getSelectedId = createSelector(
  getAcquisitionState,
  (state: AcquisitionState) => state.selectedAcquisitionId,
);

export const getSelected = createSelector(
  getAcquisitionEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId],
);

export const getLastInsertedValue = createSelector(
  getAllAcquisition,
  (acquisition: LandTitleDto[]) => acquisition[0],
);

export const getSearchAcquisition = createSelector(
  getAllAcquisition,
  getSelectedId,
  (acquisition: LandTitleDto[], selectedId) => {
    if (selectedId === ".") {
      return acquisition;
    }

    return !selectedId ? null : acquisition.filter(
      (item) =>
        item.LandName.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        ) ||
        item.ApprovalStatus.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        ) ||
        item.CommunityName.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        ),
    );
  },
);

export const getSearchacquisitionId = createSelector(
  getAllAcquisition,
  getSelectedId,
  (acquisition: LandTitleDto[], selectedId) =>
    acquisition.find((item) => item.id === selectedId),
);
